export type Testimonial = {
  title: string;
  role: string;
  quote: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    title: 'The Design Freelancer',
    role: 'Freelance Brand Designer',
    quote:
      'I needed a more consistent way to explain deliverables and revisions. Having a structured outline gives me a much clearer starting point for each proposal.',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/a36b632a-aba2-4350-aa05-d8f9170a09b6.jpg',
  },
  {
    title: 'The Web Developer',
    role: 'Freelance Web Developer',
    quote:
      'The scope-focused approach helped me identify questions I should clarify before agreeing to a project. It gives me a more organized way to prepare client proposals.',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/d639101d-c77a-46d5-ad40-1ab1eb5fbda3.jpg',
  },
  {
    title: 'The Independent Consultant',
    role: 'Independent Business Consultant',
    quote:
      'I wanted to stop rebuilding every proposal from scratch. The prompt framework gives me a repeatable structure that I can adapt to different clients.',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/f22092fa-d575-40e9-a68c-7cc960e8dbe6.jpg',
  },
];
